/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { APIKeyCreateDTO } from '../models';
// @ts-ignore
import type { APIKeyCreateResponseDTO } from '../models';
// @ts-ignore
import type { APIKeyResponseDTO } from '../models';
// @ts-ignore
import type { APIKeyUpdateDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageAPIKeyResponseDTO } from '../models';
/**
 * ApiKeysApi - axios parameter creator
 * @export
 */
export const ApiKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new API key for the current organization.  **IMPORTANT**: The full API key is shown only once in this response. Store it securely - you won\'t be able to retrieve it again.  Requires JWT authentication (API key authentication not allowed for security).  Args:     api_key_data: Name, permissions, and optional expiration     environment: Either \"live\" or \"test\" (affects key prefix)  Returns:     APIKeyCreateResponseDTO with the full key (shown only once)
         * @summary Create Api Key
         * @param {APIKeyCreateDTO} aPIKeyCreateDTO 
         * @param {string} [environment] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyApiV1ApiKeysPost: async (aPIKeyCreateDTO: APIKeyCreateDTO, environment?: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPIKeyCreateDTO' is not null or undefined
            assertParamExists('createApiKeyApiV1ApiKeysPost', 'aPIKeyCreateDTO', aPIKeyCreateDTO)
            const localVarPath = `/api/v1/api-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIKeyCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new API key for the current organization.  **IMPORTANT**: The full API key is shown only once in this response. Store it securely - you won\'t be able to retrieve it again.  Requires JWT authentication (API key authentication not allowed for security).  Args:     api_key_data: Name, permissions, and optional expiration     environment: Either \"live\" or \"test\" (affects key prefix)  Returns:     APIKeyCreateResponseDTO with the full key (shown only once)
         * @summary Create Api Key
         * @param {APIKeyCreateDTO} aPIKeyCreateDTO 
         * @param {string} [environment] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyApiV1ApiKeysPost_1: async (aPIKeyCreateDTO: APIKeyCreateDTO, environment?: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPIKeyCreateDTO' is not null or undefined
            assertParamExists('createApiKeyApiV1ApiKeysPost_1', 'aPIKeyCreateDTO', aPIKeyCreateDTO)
            const localVarPath = `/api/v1/api-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIKeyCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an API key (soft delete).  The key will no longer work for authentication. Requires JWT authentication.
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyApiV1ApiKeysApiKeyIdDelete: async (apiKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteApiKeyApiV1ApiKeysApiKeyIdDelete', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/api-keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an API key (soft delete).  The key will no longer work for authentication. Requires JWT authentication.
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2: async (apiKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/api-keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a specific API key.  Only displays key prefix, not the full key. Requires JWT authentication.
         * @summary Get Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyApiV1ApiKeysApiKeyIdGet: async (apiKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('getApiKeyApiV1ApiKeysApiKeyIdGet', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/api-keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a specific API key.  Only displays key prefix, not the full key. Requires JWT authentication.
         * @summary Get Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyApiV1ApiKeysApiKeyIdGet_3: async (apiKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('getApiKeyApiV1ApiKeysApiKeyIdGet_3', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/api-keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all active API keys for the current organization.  Only displays key prefix (e.g., \"sk_live_abc123...\"), not the full key. Requires JWT authentication.
         * @summary List Api Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysApiV1ApiKeysGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/api-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all active API keys for the current organization.  Only displays key prefix (e.g., \"sk_live_abc123...\"), not the full key. Requires JWT authentication.
         * @summary List Api Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysApiV1ApiKeysGet_4: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/api-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an API key\'s name, permissions, active status, or expiration.  Cannot change the key itself - create a new key if needed. Requires JWT authentication.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {APIKeyUpdateDTO} aPIKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyApiV1ApiKeysApiKeyIdPatch: async (apiKeyId: string, aPIKeyUpdateDTO: APIKeyUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('updateApiKeyApiV1ApiKeysApiKeyIdPatch', 'apiKeyId', apiKeyId)
            // verify required parameter 'aPIKeyUpdateDTO' is not null or undefined
            assertParamExists('updateApiKeyApiV1ApiKeysApiKeyIdPatch', 'aPIKeyUpdateDTO', aPIKeyUpdateDTO)
            const localVarPath = `/api/v1/api-keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIKeyUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an API key\'s name, permissions, active status, or expiration.  Cannot change the key itself - create a new key if needed. Requires JWT authentication.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {APIKeyUpdateDTO} aPIKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyApiV1ApiKeysApiKeyIdPatch_5: async (apiKeyId: string, aPIKeyUpdateDTO: APIKeyUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('updateApiKeyApiV1ApiKeysApiKeyIdPatch_5', 'apiKeyId', apiKeyId)
            // verify required parameter 'aPIKeyUpdateDTO' is not null or undefined
            assertParamExists('updateApiKeyApiV1ApiKeysApiKeyIdPatch_5', 'aPIKeyUpdateDTO', aPIKeyUpdateDTO)
            const localVarPath = `/api/v1/api-keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPIKeyUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiKeysApi - functional programming interface
 * @export
 */
export const ApiKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new API key for the current organization.  **IMPORTANT**: The full API key is shown only once in this response. Store it securely - you won\'t be able to retrieve it again.  Requires JWT authentication (API key authentication not allowed for security).  Args:     api_key_data: Name, permissions, and optional expiration     environment: Either \"live\" or \"test\" (affects key prefix)  Returns:     APIKeyCreateResponseDTO with the full key (shown only once)
         * @summary Create Api Key
         * @param {APIKeyCreateDTO} aPIKeyCreateDTO 
         * @param {string} [environment] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiKeyApiV1ApiKeysPost(aPIKeyCreateDTO: APIKeyCreateDTO, environment?: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIKeyCreateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiKeyApiV1ApiKeysPost(aPIKeyCreateDTO, environment, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.createApiKeyApiV1ApiKeysPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new API key for the current organization.  **IMPORTANT**: The full API key is shown only once in this response. Store it securely - you won\'t be able to retrieve it again.  Requires JWT authentication (API key authentication not allowed for security).  Args:     api_key_data: Name, permissions, and optional expiration     environment: Either \"live\" or \"test\" (affects key prefix)  Returns:     APIKeyCreateResponseDTO with the full key (shown only once)
         * @summary Create Api Key
         * @param {APIKeyCreateDTO} aPIKeyCreateDTO 
         * @param {string} [environment] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiKeyApiV1ApiKeysPost_1(aPIKeyCreateDTO: APIKeyCreateDTO, environment?: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIKeyCreateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiKeyApiV1ApiKeysPost_1(aPIKeyCreateDTO, environment, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.createApiKeyApiV1ApiKeysPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate an API key (soft delete).  The key will no longer work for authentication. Requires JWT authentication.
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKeyApiV1ApiKeysApiKeyIdDelete(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKeyApiV1ApiKeysApiKeyIdDelete(apiKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.deleteApiKeyApiV1ApiKeysApiKeyIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate an API key (soft delete).  The key will no longer work for authentication. Requires JWT authentication.
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2(apiKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a specific API key.  Only displays key prefix, not the full key. Requires JWT authentication.
         * @summary Get Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKeyApiV1ApiKeysApiKeyIdGet(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKeyApiV1ApiKeysApiKeyIdGet(apiKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.getApiKeyApiV1ApiKeysApiKeyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a specific API key.  Only displays key prefix, not the full key. Requires JWT authentication.
         * @summary Get Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKeyApiV1ApiKeysApiKeyIdGet_3(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKeyApiV1ApiKeysApiKeyIdGet_3(apiKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.getApiKeyApiV1ApiKeysApiKeyIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all active API keys for the current organization.  Only displays key prefix (e.g., \"sk_live_abc123...\"), not the full key. Requires JWT authentication.
         * @summary List Api Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApiKeysApiV1ApiKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAPIKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApiKeysApiV1ApiKeysGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.listApiKeysApiV1ApiKeysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all active API keys for the current organization.  Only displays key prefix (e.g., \"sk_live_abc123...\"), not the full key. Requires JWT authentication.
         * @summary List Api Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApiKeysApiV1ApiKeysGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAPIKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApiKeysApiV1ApiKeysGet_4(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.listApiKeysApiV1ApiKeysGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an API key\'s name, permissions, active status, or expiration.  Cannot change the key itself - create a new key if needed. Requires JWT authentication.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {APIKeyUpdateDTO} aPIKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiKeyApiV1ApiKeysApiKeyIdPatch(apiKeyId: string, aPIKeyUpdateDTO: APIKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiKeyApiV1ApiKeysApiKeyIdPatch(apiKeyId, aPIKeyUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.updateApiKeyApiV1ApiKeysApiKeyIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an API key\'s name, permissions, active status, or expiration.  Cannot change the key itself - create a new key if needed. Requires JWT authentication.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {APIKeyUpdateDTO} aPIKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiKeyApiV1ApiKeysApiKeyIdPatch_5(apiKeyId: string, aPIKeyUpdateDTO: APIKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiKeyApiV1ApiKeysApiKeyIdPatch_5(apiKeyId, aPIKeyUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.updateApiKeyApiV1ApiKeysApiKeyIdPatch_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiKeysApi - factory interface
 * @export
 */
export const ApiKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiKeysApiFp(configuration)
    return {
        /**
         * Create a new API key for the current organization.  **IMPORTANT**: The full API key is shown only once in this response. Store it securely - you won\'t be able to retrieve it again.  Requires JWT authentication (API key authentication not allowed for security).  Args:     api_key_data: Name, permissions, and optional expiration     environment: Either \"live\" or \"test\" (affects key prefix)  Returns:     APIKeyCreateResponseDTO with the full key (shown only once)
         * @summary Create Api Key
         * @param {APIKeyCreateDTO} aPIKeyCreateDTO 
         * @param {string} [environment] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyApiV1ApiKeysPost(aPIKeyCreateDTO: APIKeyCreateDTO, environment?: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<APIKeyCreateResponseDTO> {
            return localVarFp.createApiKeyApiV1ApiKeysPost(aPIKeyCreateDTO, environment, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new API key for the current organization.  **IMPORTANT**: The full API key is shown only once in this response. Store it securely - you won\'t be able to retrieve it again.  Requires JWT authentication (API key authentication not allowed for security).  Args:     api_key_data: Name, permissions, and optional expiration     environment: Either \"live\" or \"test\" (affects key prefix)  Returns:     APIKeyCreateResponseDTO with the full key (shown only once)
         * @summary Create Api Key
         * @param {APIKeyCreateDTO} aPIKeyCreateDTO 
         * @param {string} [environment] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyApiV1ApiKeysPost_1(aPIKeyCreateDTO: APIKeyCreateDTO, environment?: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<APIKeyCreateResponseDTO> {
            return localVarFp.createApiKeyApiV1ApiKeysPost_1(aPIKeyCreateDTO, environment, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an API key (soft delete).  The key will no longer work for authentication. Requires JWT authentication.
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyApiV1ApiKeysApiKeyIdDelete(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteApiKeyApiV1ApiKeysApiKeyIdDelete(apiKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an API key (soft delete).  The key will no longer work for authentication. Requires JWT authentication.
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2(apiKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a specific API key.  Only displays key prefix, not the full key. Requires JWT authentication.
         * @summary Get Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyApiV1ApiKeysApiKeyIdGet(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<APIKeyResponseDTO> {
            return localVarFp.getApiKeyApiV1ApiKeysApiKeyIdGet(apiKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a specific API key.  Only displays key prefix, not the full key. Requires JWT authentication.
         * @summary Get Api Key
         * @param {string} apiKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyApiV1ApiKeysApiKeyIdGet_3(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<APIKeyResponseDTO> {
            return localVarFp.getApiKeyApiV1ApiKeysApiKeyIdGet_3(apiKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all active API keys for the current organization.  Only displays key prefix (e.g., \"sk_live_abc123...\"), not the full key. Requires JWT authentication.
         * @summary List Api Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysApiV1ApiKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageAPIKeyResponseDTO> {
            return localVarFp.listApiKeysApiV1ApiKeysGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all active API keys for the current organization.  Only displays key prefix (e.g., \"sk_live_abc123...\"), not the full key. Requires JWT authentication.
         * @summary List Api Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysApiV1ApiKeysGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageAPIKeyResponseDTO> {
            return localVarFp.listApiKeysApiV1ApiKeysGet_4(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an API key\'s name, permissions, active status, or expiration.  Cannot change the key itself - create a new key if needed. Requires JWT authentication.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {APIKeyUpdateDTO} aPIKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyApiV1ApiKeysApiKeyIdPatch(apiKeyId: string, aPIKeyUpdateDTO: APIKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<APIKeyResponseDTO> {
            return localVarFp.updateApiKeyApiV1ApiKeysApiKeyIdPatch(apiKeyId, aPIKeyUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an API key\'s name, permissions, active status, or expiration.  Cannot change the key itself - create a new key if needed. Requires JWT authentication.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {APIKeyUpdateDTO} aPIKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyApiV1ApiKeysApiKeyIdPatch_5(apiKeyId: string, aPIKeyUpdateDTO: APIKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<APIKeyResponseDTO> {
            return localVarFp.updateApiKeyApiV1ApiKeysApiKeyIdPatch_5(apiKeyId, aPIKeyUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiKeysApi - object-oriented interface
 * @export
 * @class ApiKeysApi
 * @extends {BaseAPI}
 */
export class ApiKeysApi extends BaseAPI {
    /**
     * Create a new API key for the current organization.  **IMPORTANT**: The full API key is shown only once in this response. Store it securely - you won\'t be able to retrieve it again.  Requires JWT authentication (API key authentication not allowed for security).  Args:     api_key_data: Name, permissions, and optional expiration     environment: Either \"live\" or \"test\" (affects key prefix)  Returns:     APIKeyCreateResponseDTO with the full key (shown only once)
     * @summary Create Api Key
     * @param {APIKeyCreateDTO} aPIKeyCreateDTO 
     * @param {string} [environment] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public createApiKeyApiV1ApiKeysPost(aPIKeyCreateDTO: APIKeyCreateDTO, environment?: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).createApiKeyApiV1ApiKeysPost(aPIKeyCreateDTO, environment, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new API key for the current organization.  **IMPORTANT**: The full API key is shown only once in this response. Store it securely - you won\'t be able to retrieve it again.  Requires JWT authentication (API key authentication not allowed for security).  Args:     api_key_data: Name, permissions, and optional expiration     environment: Either \"live\" or \"test\" (affects key prefix)  Returns:     APIKeyCreateResponseDTO with the full key (shown only once)
     * @summary Create Api Key
     * @param {APIKeyCreateDTO} aPIKeyCreateDTO 
     * @param {string} [environment] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public createApiKeyApiV1ApiKeysPost_1(aPIKeyCreateDTO: APIKeyCreateDTO, environment?: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).createApiKeyApiV1ApiKeysPost_1(aPIKeyCreateDTO, environment, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an API key (soft delete).  The key will no longer work for authentication. Requires JWT authentication.
     * @summary Delete Api Key
     * @param {string} apiKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public deleteApiKeyApiV1ApiKeysApiKeyIdDelete(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).deleteApiKeyApiV1ApiKeysApiKeyIdDelete(apiKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an API key (soft delete).  The key will no longer work for authentication. Requires JWT authentication.
     * @summary Delete Api Key
     * @param {string} apiKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).deleteApiKeyApiV1ApiKeysApiKeyIdDelete_2(apiKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a specific API key.  Only displays key prefix, not the full key. Requires JWT authentication.
     * @summary Get Api Key
     * @param {string} apiKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public getApiKeyApiV1ApiKeysApiKeyIdGet(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).getApiKeyApiV1ApiKeysApiKeyIdGet(apiKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a specific API key.  Only displays key prefix, not the full key. Requires JWT authentication.
     * @summary Get Api Key
     * @param {string} apiKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public getApiKeyApiV1ApiKeysApiKeyIdGet_3(apiKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).getApiKeyApiV1ApiKeysApiKeyIdGet_3(apiKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all active API keys for the current organization.  Only displays key prefix (e.g., \"sk_live_abc123...\"), not the full key. Requires JWT authentication.
     * @summary List Api Keys
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public listApiKeysApiV1ApiKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).listApiKeysApiV1ApiKeysGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all active API keys for the current organization.  Only displays key prefix (e.g., \"sk_live_abc123...\"), not the full key. Requires JWT authentication.
     * @summary List Api Keys
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public listApiKeysApiV1ApiKeysGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).listApiKeysApiV1ApiKeysGet_4(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an API key\'s name, permissions, active status, or expiration.  Cannot change the key itself - create a new key if needed. Requires JWT authentication.
     * @summary Update Api Key
     * @param {string} apiKeyId 
     * @param {APIKeyUpdateDTO} aPIKeyUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public updateApiKeyApiV1ApiKeysApiKeyIdPatch(apiKeyId: string, aPIKeyUpdateDTO: APIKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).updateApiKeyApiV1ApiKeysApiKeyIdPatch(apiKeyId, aPIKeyUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an API key\'s name, permissions, active status, or expiration.  Cannot change the key itself - create a new key if needed. Requires JWT authentication.
     * @summary Update Api Key
     * @param {string} apiKeyId 
     * @param {APIKeyUpdateDTO} aPIKeyUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public updateApiKeyApiV1ApiKeysApiKeyIdPatch_5(apiKeyId: string, aPIKeyUpdateDTO: APIKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).updateApiKeyApiV1ApiKeysApiKeyIdPatch_5(apiKeyId, aPIKeyUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

